import 'arrayq';

import { PureConnect, React } from '../../react';
import { IQuestionDB } from '../../types';

import cx from './style.less';
import { Btn } from '../../react-toolbox-redesign/button';
import { Modal } from '../modal';
import FocusLockFocusGuard from '../../focuslock/focuslockext';
import QUESTION_CHANGE_STATUS_BATCH_CANCEL from './action/QUESTION_CHANGE_STATUS_BATCH_CANCEL';
import QUESTION_CHANGE_STATUS_BATCH from './action/QUESTION_CHANGE_STATUS_BATCH';
import DropDownBasic, { DropDownItemBasic } from '../../react-toolbox-extended/dropdownbasic';
import { IStatusType, statusNieuw, statusses, statussesallowedbatch } from './authmodule/authcheck';
import { useridResource } from '../../participantid/resource';
import { usergroupResource } from '../../usergroup/resource';
import OPEN_DROPDOWN_STATUS from './action/OPEN_DROPDOWN_STATUS';
import selectorsdropdownStatusOpen from '../question/selectors';
import QUESTION_APPLY_STATUS_BATCH from './action/QUESTION_APPLY_STATUS_BATCH';

export default PureConnect('QuestionChangeStatusModal')(
    (state) => ({
        changing: !!state.questionReducer.batchchange,
    }),
    (dispatch) => ({
        onCancel: () => {dispatch(QUESTION_CHANGE_STATUS_BATCH_CANCEL({items: undefined, batchstatus:undefined, batchchange: false }));},       
    }),
    ({ changing, onCancel }) => {

        return (
            <Modal onEscKeyDown={onCancel} 
                visible={changing} 
                type="smallsize1"
                backdrop={true}
            >                   
                <div className={cx(!(changing) ? 'wcag-invisible' : '', 'fields-container')}  aria-hidden={!(changing)} aria-labelledby= "Verwijder notitie">
                    <FocusLockFocusGuard disabled={!(changing)}>  
                        <QuestionChangeStatusArea />
                        <QuestionChangeStatusAreaSave />
                    </FocusLockFocusGuard>
                </div>
            </Modal>     
        );
    });

export const QuestionChangeStatusArea = PureConnect('QuestionChangeStatusArea')(
        (state) => ({
            changing: !!state.questionReducer.batchchange,
            items: state.questionReducer.items,
            batchstatus: state.questionReducer.batchstatus as IStatusType,
            currentUser: useridResource.selectors.items(state),
            usergroups: usergroupResource.selectors.items(state),
            dropdownStatusOpen: selectorsdropdownStatusOpen.open(state), 
        }),
        (dispatch) => ({
            showDropdownStatusBatch: (dropdownStatusOpen: boolean) => dispatch(OPEN_DROPDOWN_STATUS({dropdownopen:dropdownStatusOpen})),
            applyStatus: (items: IQuestionDB[], batchstatus: IStatusType) => dispatch(QUESTION_APPLY_STATUS_BATCH({items, batchstatus, batchchange: true})),
        }),
        ({ changing, items, currentUser, usergroups, dropdownStatusOpen, showDropdownStatusBatch, applyStatus, batchstatus }) => {

            var currentUserid =  currentUser.length > 0 ?  currentUser[0].id : '';
            var statussesallowed = statussesallowedbatch(statusses, items, currentUserid, usergroups );
            var status: number = batchstatus ? batchstatus.id: statussesallowed.qAny() ? statussesallowed.qFirst().id: statusNieuw;
            var statusitems: DropDownItemBasic[] = [];
            // tslint:disable-next-line 
            var statusSelectie: DropDownBasic | any = undefined;
            
            if (statussesallowed && currentUserid && usergroups) {
                statusitems = statussesallowed.map((status) => {
                    var dropDownItem: DropDownItemBasic = {
                        key:status.id,        
                        name:status.name.toUpperCase(),
                        statusclass: 'status-' + status.id.toString(),     
                        prefix: 'status-',                    
                    };
                    return dropDownItem;
                });
            }          

            statusSelectie = statusitems && statusitems.length && status ? <DropDownBasic
                title={'Status'}
                value={status}
                items={statusitems}
                extraclass={'status-class'}
                prefix={'status-'}
                toggleDropDown={(key: number)=> {showDropdownStatusBatch( !dropdownStatusOpen);}}
                itemSelection={(key: number) => { 
                    batchstatus=key ? statussesallowed.qFirst((itm) =>itm.id===key): statussesallowed.qFirst(); 
                    applyStatus( items, batchstatus ); }}
            ></DropDownBasic>:null;

            return (           
                    <div className={cx(!(changing) ? 'wcag-invisible' : '', 'warning')}  aria-hidden={!(changing)} aria-labelledby= "Verwijder notitie">
                        <div className={cx('warning-container')}>
                            <div className={cx('warning-title')}>Status vraag wijzigen</div>
                            <div className={cx('warning-content')}>
                                <div>
                                     {statusSelectie} 
                                </div>
                                <p>
                                    U staat op het punt de status van <span className={cx('name-label')}>{items?items.length:0} vragen</span> te veranderen.
                                </p>
                                <p className={cx('medium')}>
                                    Deze actie kunt u niet ongedaan maken.
                                </p>
                            </div>
                        </div>
                    </div>          
            );
        });

export const QuestionChangeStatusAreaSave = PureConnect('QuestionChangeStatusAreaSave')(
            (state) => ({
                changing: !!state.questionReducer.batchchange,
                items: state.questionReducer.items,
                batchstatus: state.questionReducer.batchstatus,                
                origin: state.notemenu.origin,
            }),
            (dispatch) => ({
                onCancel: () => { dispatch(QUESTION_CHANGE_STATUS_BATCH_CANCEL({items: undefined, batchstatus: undefined, batchchange: false }));},
                onSave: (items: IQuestionDB[], batchstatus: IStatusType) => dispatch(QUESTION_CHANGE_STATUS_BATCH({items, batchstatus, batchchange: true})),
            }),
            ({ changing, items, onCancel, onSave, batchstatus }) => {

                return (           
                        <div className={cx(!(changing) ? 'wcag-invisible' : '', 'fields-container')}  aria-hidden={!(changing)} aria-labelledby= "Verwijder notitie">
                            <div className={cx('bottom-buttons-container')}>
                                <div className={cx('buttons-container', !(changing)? 'wcag-invisible' : '' )}>                            
                                    <Btn 
                                        type="button" 
                                        className={'btn'} 
                                        extraClassNames={'secondary-btn'}
                                        aria-label={'Annuleren'}
                                        aria-haspopup={false}                        
                                        tabIndex={0} 
                                        onKeyDown={(evt: any) => onCancel()}                           
                                        onClick={(evt: any) => onCancel()}                                                                                             
                                        >
                                            <span>Annuleren</span>
                                    </Btn>
            
                                    <Btn 
                                        type="button" 
                                        className={'btn'} 
                                        aria-label={'Verander status'}
                                        aria-haspopup={false}                        
                                        tabIndex={0} 
                                        disabled={false} 
                                        onKeyDown={(evt: any) => onSave(items, batchstatus)}                           
                                        onClick={(evt: any) => onSave(items, batchstatus)}                                                                                       
                                        >
                                            <span>Verander status</span>
                                    </Btn>                 
                                </div>
                            </div>
                        </div>          
                );
            });



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/question/batchChangeStatusModal.tsx